import { Address, Date, Document, Phone } from '../types/auth/User';
import { hasImageValue } from './getImageUrl';

/**
 * Interface que define os campos mínimos necessários para validação do perfil do usuário
 * Contém apenas os campos que são verificados na função validateUserProfile
 */
interface UserProfile {
  name?: string;
  email?: string;
  extra?: {
    cpf?: string;
    birthday?: Date;
    documents?: Document[];
    address?: Address[];
    phones?: Phone[];
  };
}

/**
 * Validates if a user profile has all required fields
 * @param user The user object to validate
 * @param showModal Optional callback function to show modal when profile is incomplete
 * @returns True if the profile is complete, false otherwise
 */
export function validateUserProfile(
  user: UserProfile | null | undefined,
  showModal?: () => void,
): boolean {
  if (!user) return false;

  try {
    const { name, email, extra } = user;
    const hasMobile = extra?.phones?.some(
      (p: { type: string; phone: string }) => p.type === 'mobile' && p.phone,
    );
    const doc = extra?.documents?.[0];
    const addr = extra?.address?.[0];

    const missingRequiredFields = [
      !name,
      !email,
      !extra?.cpf,
      !extra?.birthday,
      !hasMobile,
      !hasImageValue(doc?.imageFront),
      !hasImageValue(doc?.imageVerse),
      !addr?.city,
      !addr?.state,
    ].some(Boolean);

    if (showModal && missingRequiredFields) {
      showModal();
    }

    return !missingRequiredFields;
  } catch (error) {
    console.error('Erro ao validar perfil do usuário:', error);
    if (showModal) {
      showModal();
    }
    return false;
  }
}
